import React from 'react';
import styled, { css } from 'styled-components';
import PassportPicker from './components/PassportPicker';
import CustomerFillerButton from './components/CustomerFillerButton';

type FormHeaderProps = {
  setCustomerDataFromTourists: React.MouseEventHandler<HTMLButtonElement>;
  isMobile: boolean;
  showFillerButton: boolean;
};

const FormHeader = (props: FormHeaderProps) => {
  const { setCustomerDataFromTourists, isMobile, showFillerButton } = props;
  return (
    <HeaderContainer $isMobile={isMobile} $showFillerButton={showFillerButton}>
      <PassportPicker isMobile={isMobile} />
      {showFillerButton ? (
        <CustomerFillerButton
          isMobile={isMobile}
          onClick={setCustomerDataFromTourists}
        />
      ) : null}
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div<{
  $isMobile: boolean;
  $showFillerButton: boolean;
}>`
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;

  ${(props) =>
    props.$isMobile &&
    css`
      flex-direction: column;
      margin-bottom: 12px;
    `}

  ${(props) =>
    !props.$showFillerButton &&
    props.$isMobile &&
    css`
      margin-left: 8px;
      margin-bottom: 8px;
    `}
`;

export default FormHeader;
